const GET_LANGUAGES = 'GET_LANGUAGES';

export default {
	GET_LANGUAGES,
};
